export function DefinitionBox({ icon: Icon, children }) {
  return (
    <div className="onboarding-surface-pill type-caption flex gap-space-2 px-space-3 py-space-2-5 leading-snug">
      <Icon className="mt-0.5 h-4 w-4 shrink-0 text-sage-600 dark:text-sage-400" aria-hidden />
      <span>{children}</span>
    </div>
  );
}
